export function setPageMeta(title: string, description: string): void {
  if (typeof document === 'undefined') return

  document.title = title
  document.documentElement.lang = 'en-GB'

  let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'description'
    document.head.appendChild(meta)
  }
  meta.content = description
}
